import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

const quickLinks = [
  { label: "最新资讯", desc: "行业动态与速递", to: "/news", icon: "ri-newspaper-line" },
  { label: "作品库", desc: "TV / 剧场版 / OVA", to: "/works", icon: "ri-film-line" },
  { label: "角色解析", desc: "人物深度专栏", to: "/characters", icon: "ri-user-star-line" },
  { label: "全站搜索", desc: "关键词直达", to: "/search", icon: "ri-search-line" },
];

export default function HeroSidePanel() {
  const picks = newsList.slice(0, 3);

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-semibold text-foreground-900">快速入口</h3>
          <span className="text-[11px] text-foreground-400">浏览频道</span>
        </div>
        <div className="grid grid-cols-2 gap-2">
          {quickLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="group flex flex-col gap-1 rounded-md bg-background-100 px-3 py-2.5 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-md bg-background-50 text-primary-600">
                <i className={`${item.icon} text-sm`}></i>
              </span>
              <span className="text-xs font-medium text-foreground-900 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-[10px] text-foreground-400 truncate">{item.desc}</span>
            </Link>
          ))}
        </div>
      </div>

      <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-semibold text-foreground-900">今日推荐</h3>
          <Link to="/news" className="text-[11px] text-primary-600 hover:text-primary-700 cursor-pointer">
            全部
          </Link>
        </div>
        <ul className="flex flex-col divide-y divide-background-100">
          {picks.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/news/detail/${item.id}`}
                className="group flex items-start gap-2.5 py-2.5 first:pt-0 cursor-pointer"
              >
                <span className="font-heading text-sm font-bold text-primary-400 w-5 shrink-0">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="min-w-0">
                  <h4 className="text-xs font-medium text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h4>
                  <span className="text-[10px] text-foreground-400 mt-1 inline-block">{item.publishedAt}</span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
        <div className="mt-3 pt-3 border-t border-background-100">
          <p className="text-[11px] text-foreground-400 leading-relaxed">
            每日整理行业动态与作品情报，编辑部人工筛选，只留值得读的内容。
          </p>
        </div>
      </div>
    </div>
  );
}